import { render, staticRenderFns } from "./NotYet.vue?vue&type=template&id=51c43074&scoped=true&"
import script from "./NotYet.vue?vue&type=script&lang=js&"
export * from "./NotYet.vue?vue&type=script&lang=js&"
import style0 from "./NotYet.vue?vue&type=style&index=0&id=51c43074&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c43074",
  null
  
)

export default component.exports